import React from "react";
import { injectIntl } from "react-intl";
import moment from "moment";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import IFilter from "models/IFilter";
import Input from "components/Input";
import Select from "components/Select";
import DetailView from "components/DetailView";
import RangeDatepicker from "components/RangeDatepicker";
import ToggleSwitch from "components/ToggleSwitch";
import Button from "components/Button";
import FilterGenerator from "helpers/filter";
import withFilters from "helpers/withFilters";
import YearDropdown from "./YearDropdown";
import { CUSTOM_SETTINGS } from "constants/.";

interface IProps extends IFilter {
  settings: any;
}

class MyDeliveriesSearch extends React.Component<IProps> {
  public static getFilterQuery = (f) => {
    const Q = new FilterGenerator();

    if (!_.isEmpty(f.deliveryDate)) {
      Q.and("Order/DeliveryPeriodEnd", f.deliveryDate, "dateRange");
    }
    Q.and("Order/Buyer/Name", f.buyerName);
    Q.and("Order/Buyer/Number", f.buyerNumber);
    Q.and("ProductValue1/Description", f.size);

    _.isBoolean(_.get(f, "status.value")) &&
      Q.and("ShippedCompletely", f.status.value, "boolean");
    Q.and("Bio", f.bio, "boolean");
    Q.and("Order/Number", f.orderNumber);

    Q.and("Order/HarvestYear", f.harvestYear, "numberRange");

    if (f.description) {
      const checkQuery = Q.query ? true : false;
      checkQuery && Q.addText(" and (");
      Q.without("Item/Description", f.description);
      Q.or("GrowerClaims", f.description);
      checkQuery && Q.addText(")");
    }

    return Q.query;
  };

  private resetFilter = () => {
    const { intl, roleIds } = this.props;
    const settings = _.get(this.props, "settings.Settings");
    const roleId = _.get(
      settings,
      "type.value",
      settings ? settings.type : "Seller"
    );
    const { from, to } = _.get(settings, "harvestYear", {});
    const type = _.find(roleIds, ["value", roleId]);

    let harvestYear: any = {};
    if (from || to) {
      harvestYear = { from: from && Number(from), to: to && Number(to) };
    } else {
      harvestYear = {
        from: Number(moment().subtract(1, "years").format("YYYY")),
        to: Number(moment().format("YYYY")),
      };
    }

    const newFilter = {
      type,
      status: { value: false, label: intl.formatMessage({ id: "NO" }) },
      harvestYear,
    };

    const Q = new FilterGenerator();
    Q.and("ShippedCompletely", false, "boolean");
    Q.and("Order/HarvestYear", newFilter.harvestYear, "numberRange");

    this.props.generateFilter({ newFilter });
  };

  public render = () => {
    const {
      intl,
      filter,
      handleFilterChange,
      generateFilter,
      roleIds = [],
    } = this.props;

    return (
      <DetailView
        pageName={CUSTOM_SETTINGS.deliveryNotes}
        renderExpanded={() => (
          <div>
            <div className="filter-row">
              <Input
                label="BUYER_NR"
                value={filter.buyerNumber}
                onChange={(e) =>
                  handleFilterChange(e.target.value, "buyerNumber")
                }
              />
              <div className="inner-block">
                <FormattedMessage id="PURCHASE_TYPE" tagName="label" />
                <Select
                  options={roleIds.filter((r) => r.value !== "Buyer")}
                  selectedOption={filter.type}
                  onChange={(value) => handleFilterChange(value, "type")}
                  className="min-width-select-forms text-12"
                />
              </div>
            </div>
            <div className="filter-row">
              <Input
                label="SIZE"
                value={filter.size}
                onChange={(e) => handleFilterChange(e.target.value, "size")}
              />
              <div className="inner-block">
                <FormattedMessage id="DELIVERIES_COMPLETE" tagName="label" />
                <Select
                  options={[
                    { value: null, label: intl.formatMessage({ id: "ALL" }) },
                    { value: true, label: intl.formatMessage({ id: "YES" }) },
                    { value: false, label: intl.formatMessage({ id: "NO" }) },
                  ]}
                  selectedOption={filter.status}
                  onChange={(value) => handleFilterChange(value, "status")}
                  className="min-width-select-forms text-12"
                />
              </div>
            </div>
            <div className="filter-row">
              <ToggleSwitch
                label="DELIVERIES_BIO"
                on={filter.bio}
                onClick={() => handleFilterChange(!filter.bio, "bio")}
              />
              <YearDropdown
                label="HARVEST_YEAR"
                name="harvestYear"
                value={filter.harvestYear}
                onChange={handleFilterChange}
              />
            </div>
          </div>
        )}
      >
        <div className="filter-row">
          <Input
            label="ORDERS_NUMBER"
            value={filter.orderNumber}
            onChange={(e) => handleFilterChange(e.target.value, "orderNumber")}
          />
          <RangeDatepicker
            name="deliveryDate"
            label="DELIVERIES_END_DATE"
            value={filter.deliveryDate}
            handleRangeChange={handleFilterChange}
          />
        </div>
        <div className="filter-row">
          <Input
            label="BUYER_NAME"
            value={filter.buyerName}
            onChange={(e) => handleFilterChange(e.target.value, "buyerName")}
          />
          <Input
            label="ARTICLE_DESCRIPTION"
            value={filter.description}
            onChange={(e) => handleFilterChange(e.target.value, "description")}
          />
        </div>
        <div className="search-btn">
          <Button onClick={this.resetFilter}>RESET</Button>
          <Button kind="primary" onClick={generateFilter}>
            SEARCH
          </Button>
        </div>
      </DetailView>
    );
  };
}

export default withFilters({
  placeholder: "MY_DELIVERIES_SEARCH",
  pageName: CUSTOM_SETTINGS.deliveryNotes,
  fixedFilters: ["type"],
})(injectIntl(MyDeliveriesSearch));
